import React,{Component} from 'react';
import PropTypes from "prop-types";
import {get, post,postResponse,postWithHeaders, put,patch} from "../../../../server/actions";
import {BeatLoader} from 'react-spinners'
import ImageZoom from "react-medium-image-zoom";
import Modal from 'react-modal';
import NotificationSystem from 'react-notification-system';
import Datetime from 'react-datetime'
import "../../../../../node_modules/react-datetime/css/react-datetime.css";
import {_addNotificationError,_addNotification,toBase64} from "../../../../server/util";
import {category, nutritions} from '../../../../server/constants.js';
import NutritionCtrl from './nutritionCtrl';
const allergensModifyStyles = {
    content: {
        top: '30%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '25%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
const snackType = {
    drink:'Drink',
    fruitsandveggie:'Fruits & Veggie'
}
let pathUrl='';
let ingredientsList = [];
const mealItemObj={
    "active": true,
    "allergens": "",
    "calcium": 0,
    "calories": 0,
    "category": "",
    "categoryType": "",
    "cholestral": 0,
    "copper": 0,
    "dietaryFiber": 0,
    "folate": 0,
    "id": 0,
    "imageBase64Content":"",
    "imageUrl": "",
    "ingredients": "",
    "iron": 0,
    "longDescription": "",
    "magnesium": 0,
    "manganese": 0,
    "name": "",
    "niacin": 0,
    "pantothenicAcid": 0,
    "phosphorous": 0,
    "potassium": 0,
    "protein": 0,
    "riboFlavin": 0,
    "saturatedFat": 0,
    "selenium": 0,
    "shortDescription": "",
    "sodium": 0,
    "sugars": 0,
    "thiamin": 0,
    "totalCarbohydrate": 0,
    "totalFat": 0,
    "vitaminA": 0,
    "vitaminB6": 0,
    "vitaminB12": 0,
    "vitaminC": 0,
    "vitaminD": 0,
    "vitaminE": 0,
    "vitaminK": 0,
    "zinc": 0,
  }

class MenuMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            loading: false,
            menuItemId:0,
            menuItemRec:JSON.parse(JSON.stringify(mealItemObj)),
            accept_allergen:false,
            modify_allergen:false,
            modifyAllergensModalIsOpen:false,
            ingredients_List:[]
        }
        this.getMenuItemDetails=this.getMenuItemDetails.bind(this);
        this.getAllergiesByIngredients=this.getAllergiesByIngredients.bind(this);
        this.saveMenuMaster=this.saveMenuMaster.bind(this);
    }
    componentWillMount=()=>{
        const {id} = this.context.router.route.match.params;
        let _menuItemId=0;
        try{
           if(parseInt(id)>0){
            _menuItemId= parseInt(id)              
           } 
        }catch(ex){
        }        
        this.setState({menuItemId:_menuItemId},()=>{
            if(_menuItemId>0){
                this.getMenuItemDetails();
            }
        }); 
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        pathUrl= sessionStorage.getItem('ROLE')==='ROLE_CATERER'?'/caterer':'/schoolAdmin'
    }       
    onCatererImageUpload=async(name, file)=>{
        const tempUrl= window.URL.createObjectURL(file[0]);
        let _menuItemRec=this.state.menuItemRec;
            _menuItemRec['imageUrl']=tempUrl;
        this.setState({menuItemRec:_menuItemRec});
        if(file.length > 0){
            let base64 = await toBase64(file[0]);
            let base64_string = base64.split(',')[1];
            let _menuItemRec=this.state.menuItemRec;
            _menuItemRec[name]=base64_string;
            this.setState({menuItemRec:_menuItemRec});
        }
    }
    getAllergiesByIngredients=(ingredients)=>{
        ingredientsList = (((ingredients || '').trim() === '') ? [] : (ingredients || '').trim().split(','));
        if(ingredientsList.length > 0){
        this.setState({loading: true});
        let headers = {
            'Content-Type': 'application/json'
        }
        let request={
            "ingredients":ingredients
        }
        postWithHeaders(`/allergens?access_token=`,JSON.stringify(request),headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {            
            let _mealRec=this.state.menuItemRec;
            _mealRec.allergens=((data||[]).map(item=>{
                return item.name
            })).join(', ')
            
            this.setState({loading: false,menuItemRec:_mealRec})
        }).catch(
            (error) => {
                this.setState({loading: false})
                console.log('Get Allergens response', error)
            }
        );
        }
    }
    getMenuItemDetails=()=>{
        this.setState({loading: true})
        get(`/menuItems/${this.state.menuItemId}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let _menuItemRec=data||{};
            let _mealRec=JSON.parse(JSON.stringify(mealItemObj));
            _mealRec={..._mealRec,..._menuItemRec}
            
            this.setState({loading: false,menuItemRec:_mealRec})
        }).catch(
            (error) => {
                this.setState({loading: false})
                console.log('Get MenuItems response', error)
            }
        );
    }
    saveMenuMaster=()=>{
        let _menuItemRec=this.state.menuItemRec;
                _menuItemRec['schoolDetails']="/mealManage/mealSchools/"+sessionStorage.getItem('SchoolId')||0;
                this.setState({menuItemRec:_menuItemRec})
        let _menuRec= JSON.parse(JSON.stringify(this.state.menuItemRec));
        Object.keys(nutritions).map((keyName)=>{
            let _keyVal=0
            try{
                 _keyVal=(_menuRec[keyName]||0)===''?0:parseInt((_menuRec[keyName]||0));
            }catch(e){
                _keyVal=0;
            }            
            if(_keyVal<=0){
                delete _menuRec[keyName];
            }
        })
        if(this.state.accept_allergen){
        this.setState({loading: true})
        let headers = {
            'Content-Type': 'application/json'
        }
         let request=_menuRec
        if(this.state.menuItemId<=0){    
        postWithHeaders(`/menuItems?access_token=`,JSON.stringify(request),headers).then((response) => {
            if (response.ok) {
                this.setState({loading: false});
                _addNotification('Successfully Created Menu Item.',this);
                setTimeout(() => {
                    this.context.router.history.push(pathUrl+'/menuMasterList')
                }, 3000);
            } else if (!response.ok) {
                throw Error(response.statusMessage);
            }
        }).catch(
            (error) => {
                this.setState({loading: false})
                console.log('Get MenuItems response', error.message)
                _addNotificationError(error.message,this);
            }
        );
        }else{
            patch(`/menuItems/${this.state.menuItemId}?access_token=`,JSON.stringify(request)).then((response) => {
                if (response.status == 200) {
                    this.setState({loading: false});
                    _addNotification('Menu item updated successfully.',this);
                    setTimeout(() => {
                        this.context.router.history.push(pathUrl+'/menuMasterList')
                    }, 3000);
                } else if (!response.ok) {
                    throw Error(response.statusMessage);
                }
            }).catch(
                (error) => {
                    this.setState({loading: false})
                    console.log('Get MenuItems response', error.message)
                    _addNotificationError(error.message,this);
                }
            );
        }
    }else{
        _addNotificationError("Please accept allergens information",this);
    }

    }
    getImageUrl=(url)=>{
        if((url || '').includes('/MenuItemImage')){
          return `${url}?${(new Date()).getTime()}`;
        }else{
          return url;
        }
      }
      onAddingItem = (i) => (event) => {
        this.setState((state, props) => {
          state.ingredients_List[i].isChecked = !state.ingredients_List[i].isChecked;
          return {
            ingredients_List: state.ingredients_List
          }
        })
      }
    saveModifiesAllergenInfo=(e)=>{
        e.preventDefault();
        let _mealRec=this.state.menuItemRec;
            _mealRec.allergens=((this.state.ingredients_List||[]).filter(val=>val.isChecked).map(item=>{
                return item.name;
            })).join(', ')
            this.setState({modifyAllergensModalIsOpen: false,modify_allergen:false,menuItemRec:_mealRec})
    }
    render() {
        const nutritionInfo={
            color: "white",
            padding: "10px",
            background: "rgb(234, 112, 102)",
            marginTop: "5px",
        }
        return (
            <section className="mainContent full-width clearfix">
                <div className='sweet-loading'
                     style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <NotificationSystem ref="notificationSystem"/>                
                <div className="container">
                    <div className="sectionTitle">
                        <h2>{`${(this.state.menuItemId<=0)?'Add':'Edit'} Menu Item`}</h2>
                    </div>
                    <form>
                    <div className="row">
                            <div className="col-md-12">
                                <div className="panel panel-primary">
                                    <div className="panel-heading">
                                        <h3 className="panel-title">{`${(this.state.menuItemId<=0)?'Add':'Edit'} Menu Item`}</h3>
                                    </div>
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div class="form-group">
                                                    <label for="mealName">Category</label>
                                                    <select className="form-control" name="category" value={this.state.menuItemRec.category||''} onChange={(e)=>{
                                                            let _menuItemRec=this.state.menuItemRec;
                                                            _menuItemRec[e.target.name]=e.target.value;
                                                            this.setState({menuItemRec:_menuItemRec})
                                                        }}>
                                                    <option value={''}>{''}</option>
                                                    {
                                                        Object.keys(category).map((item)=>{
                                                        return <option value={item}>{category[item]}</option>
                                                        })
                                                    }
                                                        
                                                    </select>
                                                </div>
                                            </div>
                                            {(this.state.menuItemRec.category === 'snack') ? 
                                            <div className="col-md-3" style={{marginTop:'5px'}}>
                                            <div className="">
                                            <div className="styled-input-single" style={{padding: '0px 0px 5px 35px'}}>                    
                                                <input type="radio" id={'rb'+snackType.drink} name="categoryType"
                                                onChange={(e)=>{
                                                    let _menuItemRec=this.state.menuItemRec;
                                                    _menuItemRec[e.target.name]=snackType.drink;
                                                    this.setState({menuItemRec:_menuItemRec})
                                                }} checked={this.state.menuItemRec.categoryType===snackType.drink}/>
                                                <label for={'rb'+snackType.drink}>{snackType.drink}</label>
                                            </div> 
                                            </div>
                                            <div className=""> 
                                            <div className="styled-input-single" style={{padding: '0px 0px 5px 35px'}}>                    
                                                <input type="radio" id={'rb'+snackType.fruitsandveggie} name="categoryType"
                                                onChange={(e)=>{
                                                    let _menuItemRec=this.state.menuItemRec;
                                                    _menuItemRec[e.target.name]=snackType.fruitsandveggie;
                                                    this.setState({menuItemRec:_menuItemRec})
                                                }} checked={this.state.menuItemRec.categoryType===snackType.fruitsandveggie}/>
                                                <label for={'rb'+snackType.fruitsandveggie}>{snackType.fruitsandveggie}</label>
                                            </div>
                                            </div>        
                                        </div>:null}
                                            
                                            <div className="col-md-3">
                                                <div class="form-group">
                                                    <label for="mealName">Item Name</label>
                                                    <input type="text" id="mealName" name="name" 
                                                    className="form-control" 
                                                    value={this.state.menuItemRec.name} 
                                                    placeholder="Item Name" onChange={(e)=>{
                                                            let _menuItemRec=this.state.menuItemRec;
                                                            _menuItemRec[e.target.name]=e.target.value;
                                                            this.setState({menuItemRec:_menuItemRec})
                                                        }} />
                                                </div>
                                            </div>
                                            {(this.state.menuItemId<=0) ? null : <div className="col-md-3" style={{marginTop:'34px'}}>
                                                <div className="form-group">
                                                    <b><i class="fa fa-circle text-success" aria-hidden="true"></i> Active</b>
                                                </div>
                                            </div>}                                
                                        </div>
                                        <div className="row" style={{margin:'10px -15px'}}>
                                            <div className="col-md-3">
                                            {
                                                this.state.menuItemRec.imageUrl === '' ? 
                                                <div className="img-thumbnail" style={{width:'230px', height:'120px'}}></div>
                                                :<ImageZoom
                                                image={{
                                                    src:`${this.getImageUrl(this.state.menuItemRec.imageUrl)}`,
                                                    alt: "Caterer Image",
                                                    style:{maxWidth:'230px',minWidth:'230px', maxHeight:'120px', minHeight:'120px'},
                                                    className: "img-thumbnail"
                                                }}
                                                zoomImage={{
                                                    src:`${this.getImageUrl(this.state.menuItemRec.imageUrl)}`,
                                                    alt: "Caterer Image",
                                                    className: "img--zoomed"
                                                }}
                                                />
                                            }
                                            
                                                <div className="form-group">
                                                <input
                                                    placeholder=""
                                                    type="file" accept="image/png, image/jpeg"
                                                    id="emp-upload-file"
                                                    name="imageBase64Content"
                                                    className="form-control-file"
                                                    onChange={(e)=>{
                                                        this.onCatererImageUpload(e.target.name, e.target.files)
                                                    }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-9">
                                                <div class="form-group">
                                                    <label for="mealName">Long Description</label>  
                                                    <textarea name="longDescription" maxLength="250"
                                                        className="form-control" 
                                                        placeholder="Long Description" 
                                                        rows="4" value={this.state.menuItemRec.longDescription} onChange={(e)=>{
                                                            let _menuItemRec=this.state.menuItemRec;
                                                            _menuItemRec[e.target.name]=e.target.value;
                                                            this.setState({menuItemRec:_menuItemRec})
                                                        }} >                                          
                                                    </textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 form-group">
                                                <div className="form-group">
                                                    <label for="mealName">Ingredients</label>  
                                                    <textarea name="ingredients" maxLength="250"
                                                        className="form-control" 
                                                        placeholder="Ingredients" 
                                                        name="ingredients" 
                                                        value={this.state.menuItemRec.ingredients}
                                                        onChange={(e)=>{
                                                            let _menuItemRec=this.state.menuItemRec;
                                                            _menuItemRec[e.target.name]=e.target.value;
                                                            this.setState({menuItemRec:_menuItemRec})
                                                        }}
                                                        onBlur={(e)=>{
                                                            if(e.target.value!==''){
                                                                this.getAllergiesByIngredients(e.target.value);
                                                            }else{
                                                                let _menuItemRec=this.state.menuItemRec;
                                                                _menuItemRec.allergens='';
                                                                this.setState({menuItemRec:_menuItemRec})
                                                            }
                                                        }}>                                                        
                                                    </textarea>
                                                </div>
                                            </div>
                                        </div>
                                       {
                                        (this.state.menuItemRec.allergens||'').length>0?
                                        <div className="row">
                                            <div className="col-md-12">
                                            <h4 className="sub-title text-warning" style={{margin: '10px 0px'}}>Allergens</h4>
                                            <blockquote style={{margin:'10px'}}>
                                                <p className="text-danger"><i className="fa fa-exclamation-triangle text-warning" aria-hidden="true"></i> {
                                                    this.state.menuItemRec.allergens
                                                }</p>
                                            </blockquote>                       
                                            </div>
                                        </div>:null
                                       } 
                                       <div className="row">
                                        <div className="col-md-2">
                                        <div className="c_checkbox c_checkbox-inline c_checkbox-primary">
                                            <input type="checkbox" name="accept_allergen" checked={this.state.accept_allergen} 
                                            id="acceptAllergens" onChange={(e) => {
                                                    this.setState({[e.target.name]:e.target.checked?true:false});
                                                }} />
                                            <label for="acceptAllergens" style={{lineHeight:'20px'}}>Accept</label>
                                        </div>
                                        </div>
                                        <div className="col-md-2">
                                        <div className="c_checkbox c_checkbox-inline c_checkbox-primary">
                                            <input type="checkbox" name="modify_allergen" checked={this.state.modify_allergen} 
                                            id="modifyAlergens" onChange={(e) => {
                                                let _status=false;
                                                let allergens_list=[];
                                                if(e.target.checked){
                                                    _status=true;
                                                    this.state.menuItemRec.ingredients.split(',').map(item=>{
                                                        allergens_list.push({name:item, isChecked:this.state.menuItemRec.allergens.split(',').some(_item=>_item.trim()===item.trim())});
                                                    })
                                                }    
                                                this.setState({[e.target.name]:e.target.checked?true:false, modifyAllergensModalIsOpen:_status, ingredients_List:allergens_list});
                                                }} />
                                            <label for="modifyAlergens" style={{lineHeight:'20px'}}>Modify</label>
                                        </div>
                                        </div>
                                       </div>
                                        <NutritionCtrl data={this.state.menuItemRec} onValueChange={(key,value)=>{
                                                            let _menuItemRec=this.state.menuItemRec;
                                                            _menuItemRec[key]=value;
                                                            this.setState({menuItemRec:_menuItemRec})
                                                        }} />
                                        <div className="row">
                                            <div className="col-md-12 text-right">
                                                <button type="button" className="btn btn-sm btn-primary" onClick={(e)=>{
                                                    this.saveMenuMaster()
                                                }}><i
                                                    className="fa fa-save"></i><span>Save Item</span></button>
                                                <button type="button" className="btn btn-sm btn-primary" onClick={()=>{
                                                    this.context.router.history.push(pathUrl+'/menuMasterList/');
                                                }}><i
                                                    className="fa fa-times"></i><span>Cancel</span></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>                  
                            </div>
                </div>
                </form>
                <Modal
                    isOpen={this.state.modifyAllergensModalIsOpen}
                    onRequestClose={() => this.setState({modifyAllergensModalIsOpen: false, modify_allergen:false})}
                    style={allergensModifyStyles}
                    contentLabel="Allergens Info"
                >
                    <div className="modal-header text-center" style={{padding: '0 0 15px'}}>
                        <button type="button" className="close" data-dismiss="modal" onClick={() => {
                            this.setState({modifyAllergensModalIsOpen: false, modify_allergen:false})
                        }}>&times;</button>
                        <h5 className="modal-title text-center theme_red_color"><b>Modify Allergens</b>
                        </h5>
                    </div>
                        <div className="modal-body pull-left" id="schoolInfo">
                           {(this.state.ingredients_List).map((item,index)=>{
                            if((item.name || '').trim() !== ''){
                                return(
                                    <div className="col-md-12">
                                    <div className="c_checkbox c_checkbox-inline c_checkbox-primary">
                                        <input type="checkbox" name={item.name} checked={item.isChecked} 
                                        id={`ingredient${index}`} onChange={this.onAddingItem(index)} />
                                        <label for={`ingredient${index}`} style={{lineHeight:'20px'}}>{ item.name}</label>
                                    </div>
                                    </div>
                                   );
                            }   
                           })}
                           <div className="col-md-12 text-center"><button className="btn btn-primary" type="button" onClick={(e)=>this.saveModifiesAllergenInfo(e)}>{'Save'}</button></div>
                        </div>
                </Modal>
                </div>
            </section>
        );
}
}
MenuMaster.contextTypes = {
    router: PropTypes.object.isRequired
}
export default MenuMaster


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Caterer/MenuMaster/menuMaster.jsx